import { useAuth } from "../auth/AuthContext";
import SignInButton from "../ui/SignInButton";

export default function HomePage() {
  const { token, error } = useAuth();
  return (
    <div className="card">
      <h1>SiftMyMail</h1>
      <p>
        SiftMyMail helps you spot risky emails quickly. We never send your mail contents to our servers — everything
        stays in your browser.
      </p>
      <ul>
        <li>No ads. No tracking. No analytics.</li>
        <li>Tokens and email snippets stay on your device only.</li>
        <li>Rule-based scoring with clear explanations.</li>
      </ul>
      {error && <p className="error">{error}</p>}
      {!token && <SignInButton />}
      {token && <p className="notice">You are signed in. Visit the Inbox to review your recent messages.</p>}
    </div>
  );
}
